import React from "react";
import * as Party2 from "../../../domain/models/Party2";
import * as Listing3 from "../../../domain/models/Listing3";
import * as PaginationMeta1 from "../../../domain/models/PaginationMeta1";
import { getCurrentBrandHostnameAndEnv } from "../../../domain/models/Enviroment";
import { TContainerStateProps } from "../state/TContainerStateProps";
import { createChangeRouteAction } from "../state/router/createChangeRouteAction";
import { CRMHomesMenuBarContainer } from "../containers/CRMHomesMenuBarContainer/CRMHomesMenuBarContainer";
import { CRMPageWrap } from "../components/Simple/CRMPageWrap/CRMPageWrap";
import { CRMPageBody } from "../components/Simple/CRMPageBody/CRMPageBody";
import { CRMPadding } from "../components/Simple/CRMPadding/CRMPadding";
import { Padding } from "../components/BuildingBlocks/Padding";
import { SpacingColumn } from "../components/BuildingBlocks/SpacingColumn";
import { CRMSpacing } from "../models/CRMSpacing";
import { CRMCardOutside } from "../components/CRMCardOutside/CRMCardOutside";
import { CRMTitleSection } from "../components/CRMTitleSection/CRMTitleSection";
import CRMInputGeneralComponent from "../components/CRMInputs/CRMInputGeneralComponent/CRMInputGeneralComponent";
import { CRMListingTable } from "../components/CRM/CRMListings/CRMListingTable";
import { CRMPartyTable } from "../components/CRM/CRMParties/CRMPartyTable";
import { CRMKPIs } from "../components/Simple/CRMKPIs/CRMKPIs";
import { CRMHomesJobsDashboard } from "../containers/CRM/CRMHomesJobsDashboard";

const IsSailHomes = getCurrentBrandHostnameAndEnv("web", window.location.hostname) === "sailhomes";

const countLabel = (meta: PaginationMeta1.T): string =>
    meta.available_count > meta.returned_count
        ? `${meta.returned_count} / ${meta.available_count}`
        : meta.available_count.toString();

const CRMSearchPage = (props: TContainerStateProps): JSX.Element => {
    const search = props.state.activeData.crm.search;
    const onSearchChange = (searchInput: string) => props.dispatch({
        type: "CRM_SEARCH_INPUT_CHANGED",
        payload: searchInput,
    });

    return (
        <CRMPageWrap>
            <CRMHomesMenuBarContainer {...props} />

            <CRMPageBody>
                <Padding type="vertical" spacing={CRMSpacing.LARGE}>
                    <SpacingColumn spacing={CRMSpacing.LARGE}>

                        {/* Sail Homes searches in an overlay, so the board is no longer
                            swapped out from under you the moment you type. The other
                            brands keep the in-page search they have always had. */}
                        {IsSailHomes && <CRMHomesJobsDashboard {...props} />}

                        {!IsSailHomes && <>
                            <CRMCardOutside borderRounding="right" shadow={true}>
                                <CRMPadding size="large">
                                    <CRMInputGeneralComponent
                                        inputType="text"
                                        displayError={false}
                                        placeholder="Search for a buyer, seller or property..."
                                        value={search.searchInput}
                                        onChange={onSearchChange}
                                        autoFocus={true}
                                    />
                                </CRMPadding>
                            </CRMCardOutside>

                            {/* LISTINGS */}
                            <CRMCardOutside borderRounding="right" shadow={true}>
                                <CRMPadding size="large">
                                    <SpacingColumn spacing={CRMSpacing.LARGE}>
                                        <CRMTitleSection>{`Listings (${countLabel(search.listingsSearchResponse.response.meta)} results)`}</CRMTitleSection>
                                        <CRMListingTable
                                            listings={search.listingsSearchResponse.response.data}
                                            showLoadMore={search.listingsSearchResponse.response.meta.available_count > search.listingsSearchResponse.response.meta.returned_count}
                                            onLoadMore={() => props.dispatch({ type: "CRM_SEARCH_LOAD_MORE_LISTINGS" })}
                                            onListingClick={(listing: Listing3.T) =>
                                                props.dispatch(createChangeRouteAction(
                                                    "VIEW_CRM_LISTING",
                                                    { listingId: listing.id },
                                                    { visible_tab: "", visible_sections: "" },
                                                ))
                                            }
                                            onSellerClick={(listing: Listing3.T) =>
                                                props.dispatch(createChangeRouteAction(
                                                    "VIEW_CRM_LISTING",
                                                    { listingId: listing.id },
                                                    { visible_tab: "seller_details", visible_sections: "" },
                                                ))
                                            }
                                        />
                                    </SpacingColumn>
                                </CRMPadding>
                            </CRMCardOutside>

                            {/* PARTIES */}
                            <CRMCardOutside borderRounding="right" shadow={true}>
                                <CRMPadding size="large">
                                    <SpacingColumn spacing={CRMSpacing.LARGE}>
                                        <CRMTitleSection>{`Parties (${countLabel(search.partiesSearchResponse.response.meta)} results)`}</CRMTitleSection>
                                        <CRMPartyTable
                                            parties={search.partiesSearchResponse.response.data}
                                            showLoadMore={search.partiesSearchResponse.response.meta.available_count > search.partiesSearchResponse.response.meta.returned_count}
                                            onLoadMore={() => props.dispatch({ type: "CRM_SEARCH_LOAD_MORE_PARTIES" })}
                                            onPartyClick={(party: Party2.T) => props.dispatch(createChangeRouteAction(
                                                "VIEW_CRM_PARTY",
                                                { partyId: party.id },
                                                {},
                                            ))}
                                        />
                                    </SpacingColumn>
                                </CRMPadding>
                            </CRMCardOutside>
                        </>}

                    </SpacingColumn>
                </Padding>
            </CRMPageBody>

            {/* WEEKLY KPIS */}
            <CRMKPIs
                isOpen={props.state.forms.weekly_kpi_is_showing}
                onClose={() => props.dispatch({ type: "CRM_CLOSE_WEEKLY_KPIS" })}
            />
        </CRMPageWrap>
    );
};

export default CRMSearchPage;
